import { useRef, useEffect } from 'react';

const Tooltip = ( props ) => {
    
    const main = useRef(null)
    const content = useRef(null)
    const toggle = useRef(null)

    const isMobile = () => {
        return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }


    useEffect(() => {

        let timeResize = false

        const checkPosition = () => {

            // Position
            content.current.classList.remove( 'to-left', 'to-center' )
            setTimeout( () => {

                const mainRect = main.current.getBoundingClientRect()
                const mainRight = Math.floor(  window.innerWidth - ( mainRect.left + mainRect.width ) )
                const contRect = content.current.getBoundingClientRect()
                const sideSpace = Math.ceil( ( contRect.width - mainRect.width ) / 2 )

                // Center
                if( mainRight >= sideSpace  ){
                    content.current.classList.add( 'to-center' )
                }

            }, 10 )

            // Toggle
            if( isMobile() ){
                const bindAct = () => {
                    main.current.classList.toggle( 'opened' )
                }
                toggle.current.addEventListener( 'click', bindAct )
                toggle.current.addEventListener( 'tap', bindAct )
            }
            
        }
        
        // Position
        const binResize = () => {
            if( timeResize ) clearTimeout( timeResize )
            timeResize = setTimeout( () => {
                checkPosition()
            }, 100 )
        }
        window.addEventListener( 'resize', binResize )
        checkPosition()

        // Mobile clickout
        function handleClickOutside( event ){
            if( event.target !== main.current && !main.current.contains( event.target ) ){
                main.current.classList.remove('opened');
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
    
        return () => {
            window.removeEventListener( 'resize', binResize )
            document.removeEventListener( 'mousedown', handleClickOutside )
        }
    
    }, [])

    return(
    <div ref={main} className='tooltip'>
        <span ref={toggle} className='duvida'>?</span>
        <div ref={content}>{props.content}</div>
    </div>);

}

export default Tooltip